import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';

const ROWS = [
  {
    myth: 'If the charges were withdrawn, you automatically win.',
    fact: 'Not automatic. Withdrawn charges can be an indicator, but the court still asks whether the arrest itself was lawful under the CPA and the Constitution.',
  },
  {
    myth: 'You can only claim if you were beaten in custody.',
    fact: 'No. The deprivation of liberty is itself a recognised head of damages — even without physical injury.',
  },
  {
    myth: 'SAPS can arrest you on suspicion alone.',
    fact: 'Only within the strict tests set by section 40 of the Criminal Procedure Act. A merely subjective suspicion is not enough — it must be reasonable and objectively justifiable.',
  },
  {
    myth: 'You must sue quickly or you lose everything.',
    fact: 'Time matters — the standard prescription period is 3 years under the Prescription Act — but the exact position depends on the facts. Do not delay in seeking advice.',
  },
  {
    myth: 'Being arrested with a warrant means you have no claim.',
    fact: 'Not always. A warrant obtained improperly, executed unlawfully, or based on false information may still ground a claim.',
  },
  {
    myth: 'A lawyer costs too much to even ask.',
    fact: 'Our online assessment is free. Fee arrangements are discussed openly before any work begins — no obligation, no surprises.',
  },
];

export default function MythsFacts() {
  return (
    <section data-testid="myths-facts" className="relative py-24 md:py-32 border-t border-white/5">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <div className="max-w-3xl">
          <div className="text-[11px] font-inter font-bold uppercase tracking-[0.28em] text-[#FFD400]">Chapter 05 — Setting the record straight</div>
          <h2 className="mt-4 font-poppins font-bold text-white text-4xl md:text-5xl lg:text-6xl tracking-[-0.02em] leading-[1.02]">
            Myths vs. <span className="text-[#39A8FF]">facts.</span>
          </h2>
        </div>

        <div className="mt-14 divide-y divide-white/5 border-y border-white/5">
          {ROWS.map((r, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-40px' }}
              transition={{ duration: 0.55, delay: i * 0.04 }}
              data-testid={`myth-row-${i}`}
              className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-10 py-8 md:py-10"
            >
              <div className="flex items-start gap-4">
                <span className="flex-shrink-0 mt-1 inline-flex h-8 w-8 items-center justify-center rounded-full border border-red-500/30 bg-red-500/10">
                  <X className="h-4 w-4 text-red-400" strokeWidth={2.4} />
                </span>
                <div>
                  <div className="text-[10px] font-inter font-bold uppercase tracking-[0.28em] text-red-400/80">Myth</div>
                  <p className="mt-2 font-poppins font-semibold text-white/85 text-lg leading-snug">{r.myth}</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <span className="flex-shrink-0 mt-1 inline-flex h-8 w-8 items-center justify-center rounded-full border border-[#39A8FF]/40 bg-[#39A8FF]/10">
                  <Check className="h-4 w-4 text-[#39A8FF]" strokeWidth={2.4} />
                </span>
                <div>
                  <div className="text-[10px] font-inter font-bold uppercase tracking-[0.28em] text-[#FFD400]">Fact</div>
                  <p className="mt-2 font-inter text-white/85 text-[15px] md:text-base leading-relaxed">{r.fact}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
